/**
 * One-row-at-a-time accordion (Debut's product page behaviour) for Horizon's native accordion block.
 * blocks/lc-page-content.liquid renders <lc-exclusive-accordion> inside an accordion row; on connect it gives every
 * direct row of the enclosing `.accordion` (`.accordion > accordion-custom > details`) the same `name`, so the browser's
 * exclusive-accordion feature closes the others with no listeners. Nested <details> inside page content are left alone.
 * Idempotent and re-runnable: several rows in one accordion, and editor re-renders, converge on the same name.
 */
let counter = 0;

class LcExclusiveAccordion extends HTMLElement {
  connectedCallback() {
    const accordion = this.closest('.accordion');
    if (!(accordion instanceof HTMLElement)) return;
    if (!accordion.dataset.lcExclusive) accordion.dataset.lcExclusive = String(++counter);
    const name = `lc-accordion-${accordion.dataset.lcExclusive}`;
    let seenOpen = false;
    for (const details of accordion.querySelectorAll(':scope > accordion-custom > details')) {
      if (!(details instanceof HTMLDetailsElement)) continue;
      details.setAttribute('name', name);
      if (details.open) {
        if (seenOpen) details.open = false;
        seenOpen = true;
      }
    }
  }
}

if (!customElements.get('lc-exclusive-accordion')) {
  customElements.define('lc-exclusive-accordion', LcExclusiveAccordion);
}
